import Map from "../map/Map";
import { getPopup } from "./popup";
import { scrollToSelectedLocation } from "../map/scroll-to-place";

class PlacesToVisit {
  constructor(DOMelement, store) {
    try {
      this.el = DOMelement;
      this.store = store;
      this.listWrapper = this.el.querySelector(".locations-list");
      this.mapEl = this.el.querySelector('[id^="places-to-visit-sd-map"]');
  
      this.closeAllPopUps = this.closeAllPopUps.bind(this);
      this.onMarkerClick = this.onMarkerClick.bind(this);
      this.onLocationClick = this.onLocationClick.bind(this);
      this.map = new Map(this.mapEl, store, this.onMarkerClick);
  
      this.data_geo_attr = this.mapEl.getAttribute("data-geo");
      this.scriptID = document.querySelector(`#${this.data_geo_attr}`);    
      this.scriptData = this.scriptID.innerText;
      this.mapData = JSON.parse(this.scriptData);
      this.locationsData = this.mapData.geolocations;
  
      this.locations = this.el.querySelectorAll(".locations-place");
      this.locations.forEach((item, i) => {
        item.addEventListener("click", (e) =>
          this.onLocationClick(e.currentTarget, this.locationsData[i])
        )
      })
  
      this.addCounterToList();
    } catch (error) {
      console.log(error);
    }
  }

  addCounterToList() {
    let listItems = this.listWrapper.querySelectorAll(".locations-place");
    for(const [i, item] of listItems.entries()) {
      item.setAttribute("data-list-counter", i + 1)
    }
  }

  closeAllPopUps() {
    if (this.map.popUps.length) {
      this.map.popUps.forEach((item) => item.remove());
    }
  }

  onMarkerClick(data, idx) {
    this.closeAllPopUps();
    this.locations.forEach((item) => item.classList.remove("active"));
    this.locations[idx].classList.add("active");
    scrollToSelectedLocation(this.locations[idx], this.listWrapper);
    const popupHtml = getPopup(data);
    const popup = new this.map.mapbox.Popup({ closeOnClick: false })
      .setLngLat([data.longitude, data.latitude])
      .setHTML(popupHtml);
    this.map.popUps.push(popup);
    popup.addTo(this.map.map);
    popup._closeButton.addEventListener("click", () => {
      this.locations.forEach((item) => item.classList.remove("active"));
    })
    this.map.map.flyTo({
      center: [data.longitude, data.latitude],
      essential: true,
    });
  }

  onLocationClick(el, locationData) {
    this.locations.forEach((item) => item.classList.remove("active"));
    el.classList.add("active");
    let idx = this.locationsData.findIndex(item => item.imageId === locationData.imageId);
    this.onMarkerClick(locationData, idx);
  }

}

export default PlacesToVisit;
